import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters(['loginState', 'getIsApp', 'getIsAuthorized'])
  },
  methods: {
    ...mapMutations(['AUTHORIZE_POPUP_SHOW']),
    checkLoginBeforeOperation(callback) {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    }
  }
}
